"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyEventToEventInvitation = exports.HuntingEvent = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
class HuntingEvent {
    constructor() {
        this.className = "HuntingEvent";
        this.identifier = undefined;
        this.contextId = undefined;
        this.date = undefined;
        this.name = undefined;
        this.active = false;
        this.treibenCount = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        this.comment = undefined;
        this.updateTimestamp = undefined;
        this.creationDate = undefined;
        this._structureVersion = undefined;
    }
    setFromAny(element) {
        const { identifier, contextId, date, name, active, treibenCount, huntingDistrictId, updateTimestamp, creationDate, _structureVersion, comment, huntingDistrictName } = element;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.creationDate = (0, obejct_diff_1.firestoreTimestampToDate)(creationDate ? creationDate : this.creationDate);
        this.updateTimestamp = (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp ? updateTimestamp : this.updateTimestamp);
        this.date = (0, obejct_diff_1.firestoreTimestampToDate)(date ? date : this.date);
        this.name = name ? name : this.name;
        this.active = active ? active : this.active;
        this.treibenCount = treibenCount ? treibenCount : this.treibenCount;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion;
        this.comment = comment ? comment : this.comment;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
    }
    searchFilter(filter) {
        const str = `${this.name}`.toLowerCase();
        return str.includes(filter);
    }
    getListItemTitle() {
        return this.name ? this.name : 'No name configured';
    }
    replacerFn(key) {
        return true;
    }
}
exports.HuntingEvent = HuntingEvent;
HuntingEvent.className = "HuntingEvent";
exports.DependencyEventToEventInvitation = {
    collectionName: network_constants_1.NetworkConstants.COLLECTION_EVENT_INV,
    mapping: new Map([
        ["name", "eventName"],
        ["date", "eventDate"],
        ["huntingDistrictId", "huntingDistrictId"],
        ["huntingDistrictName", "huntingDistrictName"]
    ]),
    getQuery: (firestore, origin, now) => {
        return (now != null) ? firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT_INV)
            .where('eventId', '==', origin['identifier'])
            .where('eventDate', '>=', now)
            :
                firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT_INV)
                    .where('eventId', '==', origin['identifier']);
    },
    getDoc: (firestore, identifier) => {
        return null;
    }
};
